<template>
	<div class="nup_main">
		<div class="new_content">
			<div class="new_webposition">
				<router-link :to="{ path: '/usercenter'}">学习中心</router-link>
				<span class="nje_jiange">&gt;</span><span class="nje_last">绑卡记录</span></div>
			<div class="nupmrm_case">
				<div class="npm_caseDiv9" style="padding-left: 0px;">
					<div class="npm_caseDiv9_right">
						
						<el-button class="f_r" size="small" style="margin-left: 15px;" type="primary" @click="searchList">搜索
						</el-button>
						<el-input v-model="searchForm.cardNum" class="f_r" placeholder="按学习卡卡号模糊搜索"
							size="small" style="display:inline-block;width:200px;"></el-input>
					</div>
				</div>
			</div>
			<div class="nupmrm_content">
				<el-table v-loading="listLoading" :data="cardListInit" highlight-current-row style="width: 100%;">
					<el-table-column label="学习卡卡号" prop="cardNumber" show-overflow-tooltip width="140"></el-table-column>
					<el-table-column label="学习卡有效期" prop="startDate" width="190">
						<template slot-scope="scope">
							{{ scope.row.startDate }}至{{ scope.row.endDate }}
						</template>
					</el-table-column>
					<el-table-column label="使用范围" prop="trainingNames" show-overflow-tooltip width="350"></el-table-column>
					<el-table-column label="绑卡时间" prop="bandTime" width="160"></el-table-column>
					<el-table-column label="总学分" prop="credit" width="50"></el-table-column>
					<el-table-column label="已用学分" prop="alreadyUsed" width="50"></el-table-column>
					<el-table-column label="剩余学分" prop="rest" width="50"></el-table-column>
				</el-table>
				<el-col :span="24" class="toolbar" style="padding-top: 12px;">
					<el-pagination :current-page="searchForm.currentPage" :page-size="searchForm.pageSize"
						:total="searchForm.total" layout="total, prev, pager, next" style="float:right;"
						@current-change="handleExamCurrentChange">
					</el-pagination>
				</el-col>
			</div>
		</div>
	
	</div>


</template>

<script>
import { mapGetters } from 'vuex'
import { getMyCardList } from '../../api/api'


export default {
	data() {
		return {
			cardListInit: [],
			listLoading: false,
			searchForm: {
				currentPage: 1,//当前页数
				pageSize: 10,//每页显示条目个数
				total: 0, //总条目数
				cardNum: '',
				userId: ''
			}
		}
	},
	computed: {
		...mapGetters([
			'userInfo'
		])
	},
	methods: {
		
		searchList() {
			this.searchForm.currentPage = 1
			this.listCardInit()
		},
		
		listCardInit() {
			if (this.$storejs.get(process.env.APPKEY + 'token') == undefined) {
				this.$alert('请刷新检查登陆状态', '提示', {
					confirmButtonText: '确定',
					callback: action => {
						this.$router.push('/')
					}
				})
				return false
			}
			this.listLoading = true
			getMyCardList({...this.searchForm, source: 'shiyan'}).then((res) => {
				this.searchForm.total = res.data.data.total
				this.cardListInit = res.data.data.list
				this.listLoading = false
			}).catch(() => {
				this.listLoading = false
				this.$message({
					type: 'info',
					message: '加载失败！'
				})
			})
		},
		
		handleExamCurrentChange(val) {
			this.searchForm.currentPage = val
			this.listCardInit()
		}
	},
	mounted() {
		this.searchForm.userId = this.userInfo.id
		this.listCardInit()
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/usercenter/MyCard.vue